import React, { useEffect } from 'react';
import useApp from 'hooks/useApp'
import { Button } from 'components'
import nhSymbol from 'images/tmp_nh_symbol.png'
import wooriSymbol from 'images/tmp_woori_symbol.png'
import shSymbol from 'images/tmp_shinhan_symbol.png'
import styles from './index.module.css'

const DataFail = () => {

	const App = useApp()

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: "",
			right: <i className="icon icon_close" />
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="flex_1 padding">
				<h3 style={{ fontWeight: 500 }}>불러오지 못한<br />기관을 확인해보세요.</h3>
				<div className="check-area mt_20">
					<div className="check-list">
						<div className="justify_start">
							<div className="img-box img-symbol">
								<img src={nhSymbol} alt="" />
							</div>
							<div className="ml_10 block">
								<p>SC제일은행</p>
								<span className="list-info">존재하지 않는 고객입니다.</span>
							</div>
						</div>
						<div className="justify_start">
							<div className="img-box img-symbol">
								<img src={nhSymbol} alt="" />
							</div>
							<div className="ml_10 block">
								<p>NH농협은행</p>
								<span className="list-info">존재하지 않은 고객입니다.</span>
							</div>
						</div>
						<div className="justify_start">
							<div className="img-box img-symbol">
								<img src={shSymbol} alt="" />
							</div>
							<div className="ml_10 block">
								<p>알씨아이파이낸셜서비스코리아</p>
								<span className="list-info">자산정보가 존재하지 않습니다.</span>
							</div>
						</div>
						<div className="justify_start">
							<div className="img-box img-symbol">
								<img src={wooriSymbol} alt="" />
							</div>
							<div className="ml_10 block">
								<p>SC제일은행(카드)</p>
								<span className="list-info">존재하지 않은 고객입니다.</span>
							</div>
						</div>
						<div className="justify_start">
							<div className="img-box img-symbol">
								<img src={nhSymbol} alt="" />
							</div>
							<div className="ml_10 block">
								<p>NH농협카드</p>
								<span className="list-info">존재하지 않은 고객입니다.</span>
							</div>
						</div>
						<div className="justify_start">
							<div className="img-box img-symbol">
								<img src={wooriSymbol} alt="" />
							</div>
							<div className="ml_10 block">
								<p>우리카드</p>
								<span className="list-info">자산정보가 존재하지 않습니다.</span>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="flex-shrink_0 padding">
				<Button className="btn btn--big">확인</Button>
			</div>
		</div>
	)
}

export default DataFail